import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const calendar: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M1 1h2.25v-2.25H1zm2.75 0h2.5v-2.25h-2.5ZM1-1.75h2.25v-2.5H1zm2.75 0h2.5v-2.5h-2.5ZM1-4.75h2.25V-7H1zM6.75 1h2.5v-2.25h-2.5Zm-3-5.75h2.5V-7h-2.5Zm6 5.75H12v-2.25H9.75Zm-3-2.75h2.5v-2.5h-2.5ZM4-8.5v-2.25a.22.22 0 0 0-.078-.172A.22.22 0 0 0 3.75-11h-.5a.24.24 0 0 0-.172.078.2.2 0 0 0-.078.172v2.25c0 .063.023.121.078.172.05.055.11.078.172.078h.5c.07 0 .129-.023.172-.078Q3.998-8.405 4-8.5m5.75 6.75H12v-2.5H9.75Zm-3-3h2.5V-7h-2.5Zm3 0H12V-7H9.75ZM10-8.5v-2.25a.22.22 0 0 0-.078-.172A.22.22 0 0 0 9.75-11h-.5a.24.24 0 0 0-.172.078.2.2 0 0 0-.078.172v2.25c0 .063.023.121.078.172.05.055.11.078.172.078h.5c.07 0 .129-.023.172-.078q.076-.077.078-.172m3-.5V1c0 .27-.102.504-.297.703A.98.98 0 0 1 12 2H1a.96.96 0 0 1-.703-.297A.96.96 0 0 1 0 1V-9a.96.96 0 0 1 .297-.703A.96.96 0 0 1 1-10h1v-.75c0-.344.117-.633.36-.875Q2.734-12 3.25-12h.5c.344 0 .633.125.875.375q.375.361.375.875v.75h3v-.75c0-.344.117-.633.36-.875Q8.733-12 9.25-12h.5c.344 0 .633.125.875.375q.375.361.375.875v.75h1c.27 0 .504.102.703.297.195.2.297.433.297.703m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "13",
  }
};